import { forwardRef } from "react";
const SvgEuro = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M13 3.07545C11.9692 2.39756 10.7157 2 9.36364 2C6.59287 2 4.2357 3.66962 3.3621 6M13 12.9246C11.9692 13.6024 10.7157 14 9.36364 14C6.59287 14 4.2357 12.3304 3.3621 10M3.3621 6H9M3.3621 6C3.1276 6.62556 3 7.29873 3 8C3 8.70127 3.1276 9.37444 3.3621 10M3.3621 10H9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" /></svg>;
const ForwardRef = forwardRef(SvgEuro);
export default ForwardRef;